export const dealersStatsActions = {
    STORE_STATS: 'dealersStats/STORE_STATS',
    STORE_STATS_EXIST_STATUS: 'dealersStats/STORE_STATS_EXIST_STATUS',
    FETCH_STATS_EXIST_REQUEST_STATUS: 'dealersStats/FETCH_STATS_EXIST_REQUEST_STATUS',
    FETCH_STATS_REQUEST_STATUS: 'dealersStats/FETCH_STATS_REQUEST_STATUS',
    EXPORT_STATS_REQUEST_STATUS: 'dealersStats/EXPORT_STATS_REQUEST_STATUS',
    RESET_STATS: 'dealersStats/RESET_STATS',
}
